import { render, staticRenderFns } from "./QuickInfo.vue?vue&type=template&id=44ffe67a&"
import script from "./QuickInfo.vue?vue&type=script&lang=js&"
export * from "./QuickInfo.vue?vue&type=script&lang=js&"
import style0 from "./QuickInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuickInfo.vue"
export default component.exports